import {Practice} from '@practicegenius/domain/src/data/practice';
import {useUserProfile} from '../../components/UserProfileProvider';
import {useApi} from '../../http/AuthApiProvider';

/**
 * In theory, we should be able to fetch this statically from the subdomain in the host header
 * We don't currently have that ability at hand, so this uses the practice id from the core JWT
 */
/** Get the Practice info for the currently-logged-in practice */
export const useActivePractice = (): Practice => {
  const {practices} = useUserProfile();
  const {decodedToken} = useApi();

  const practice = practices.find(p => p.id === decodedToken.practiceId);
  if (!practice)
    throw new Error(
      'Not able to find an entry for the current practice in the user profile!'
    );

  return practice;
};
